import React, { useState, useEffect } from 'react';
import { Empty, Input, Select } from 'antd';
import PropTypes from 'prop-types';
import { GalleryTags } from 'utils/data/GalleryTagsModal';
import uploaderApi from 'utils/api/Uploader/UploaderApi';
import './GalleryGrid.less';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const { Search } = Input;

const GalleryGrid = (props) => {
  // coverImage and handleSelectedImage comes from GeneralOfferForm.
  const { coverImage, handleSelectedImage, cleanChild } = props;
  const imageSelectedMessage = coverImage || 'Selecciona una Imagen';
  const [selectValue, setSelectValue] = useState(undefined);
  const [selectTagData, setSelectTagData] = useState([]);
  const [filterValue, setFilterValue] = useState('');
  const [imageSelected, setImageSelected] = useState(imageSelectedMessage);
  const emptyMessage = selectValue
    ? 'Pruebe con otro tag'
    : 'Seleccione un Tag';

  const { Option } = Select;

  /**
   * Method to handler the select filter
   */
  // eslint-disable-next-line max-len
  const handlerFilterOption = (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;

  /**
   * HandleOnselect Image
   * @param value
   */
  const handleSelectOnchange = (value) => {
    setSelectValue(value);
  };

  /**
   * handleOnClickImage
   * @param e
   */
  const handleOnClickImage = (e) => {
    setImageSelected(e.url);
    handleSelectedImage(e.url);
  };

  const renderImageButton = (img, index) => (
    <div className="gallery-column-image-container">
      <button
        onClick={() => handleOnClickImage(img)}
        type="button"
        className="gallery-column-image-button"
      >
        <LazyLoadImage
          wrapperClassName="gallery-column-image"
          src={img.thumbnail}
          alt={index}
          effect="opacity"
          width="100%"
        />
      </button>
    </div>
  );

  const handleRenderImagesGrid = () => selectTagData.map((img, index) => {
    let element = false;
    if (filterValue.length > 0) {
      if (img.name.toLowerCase().includes(filterValue)) {
        element = renderImageButton(img, index);
      }
    } else element = renderImageButton(img, index);
    return element;
  });

  /**
   * Method to render the Grid with data or empty
   */
  const handleRenderGrid = () => {
    if (coverImage && !selectValue) {
      return (
        <div className="gallery-cover-image-selected">
          <img src={coverImage} alt="coverImage" />
          <p>Imagen de portada actualmente seleccionada</p>
        </div>
      );
    }
    if (selectTagData.length) {
      return <div className="gallery-grid">{handleRenderImagesGrid()}</div>;
    }
    return (
      <Empty className="gallery-empty-component" description={emptyMessage} />
    );
  };

  /**
   * UseEffect to request the images for different tags.
   */
  useEffect(() => {
    if (selectValue) {
      uploaderApi
        .getImages(selectValue)
        .then((res) => setSelectTagData(res.data));
    }
  }, [selectValue]);

  /**
   * UseEffect to save the coverImage
   */
  useEffect(() => {
    setImageSelected(coverImage);
  }, [coverImage]);

  /**
   * UseEffect to clean the child
   */
  useEffect(() => {
    setSelectValue(undefined);
  }, [cleanChild]);

  return (
    <div className="gallery-grid-container">
      <div className="gallery-header">
        <Select
          showSearch
          className="gallery-select-component"
          optionFilterProp="children"
          value={selectValue}
          placeholder="Selecciona un tag"
          onChange={handleSelectOnchange}
          filterOption={handlerFilterOption}
        >
          {GalleryTags.map((tag) => (
            <Option value={tag.value}>{tag.label}</Option>
          ))}
        </Select>
        <Search
          className="gallery-header-input"
          onSearch={(value) => {
            setFilterValue(value.trim().toLowerCase());
          }}
        />
        <Input
          className="gallery-header-input"
          value={imageSelected}
          disabled
        />
      </div>
      {handleRenderGrid()}
    </div>
  );
};

GalleryGrid.propTypes = {
  cleanChild: PropTypes.bool.isRequired,
  coverImage: PropTypes.string.isRequired,
  handleSelectedImage: PropTypes.func.isRequired,
};

export default GalleryGrid;
